export enum AdditionalFieldTypes {
  'dropdown-level1' = 'dropdown-level1',
  'dropdown-level2' = 'dropdown-level2',
  'dropdown-level3' = 'dropdown-level3',
  'string' = 'string',
  'phone' = 'phone',
  'email' = 'email',
  'radio' = 'radio',
  'contact' = 'contact',
  'colombia_address' = 'colombia_address',
  'number' = 'number'
}
